import type {View} from '../view/types';
import {themeIntent, forceApplyThemesIntent} from './intent';
import type {ThemeIntent, ThemePolicy} from './types';

export function isTheme(intent: unknown): intent is ThemeIntent {
  return (
    themeIntent.isIntent(intent) || forceApplyThemesIntent.isIntent(intent)
  );
}

export function getThemeIntents<Props>(
  theme: ThemeIntent,
  themePolicy?: ThemePolicy,
): View.Intent<Props>[] {
  if (themePolicy === 'block-all') {
    return [];
  }
  if (
    themePolicy === 'allow-forced-only' &&
    !forceApplyThemesIntent.isIntent(theme)
  ) {
    return [];
  }
  return theme.intents as View.Intent<Props>[];
}
